import EditIcon from "@mui/icons-material/Edit"
import { IconButton } from "@mui/material"
import { useNavigate } from "react-router"
import { OrganisationDto } from "@custom-types/organisation"
import { ReactNode, useCallback, useMemo } from "react"
import { getMaterialTableColumns } from "./const"
import { ExportTransformOutput, Table } from "@components/Table"
import { MRT_Row } from "material-react-table"

type OrganisationsTableProps = {
  data: OrganisationDto[] | undefined
  exportTransformFn?: (data: OrganisationDto[]) => ExportTransformOutput
}

export default function OrganisationsTable({
  data = [],
  exportTransformFn = undefined,
}: OrganisationsTableProps) {
  const navigate = useNavigate()

  const handleEditClick = (id: string) => () => {
    navigate(`/Administration/Organisations/${id}`)
  }

  const materialTableColumns: {
    accessorKey: string
    header: string
    size?: number
    muiTableBodyCellProps?: {}
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ANY :(
    Cell?: (props: any) => ReactNode
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
  }[] = useMemo(() => getMaterialTableColumns(), [getMaterialTableColumns])

  const getRowActions = useCallback(
    ({ row }: { row: MRT_Row<OrganisationDto> }) => (
      <IconButton onClick={handleEditClick(row.original.key)}>
        <EditIcon />
      </IconButton>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIX: deps after bulk migration
    [],
  )

  return (
    <Table
      sessionStorageName={"organizationsTable"}
      isExportable
      enableRowActions
      columns={materialTableColumns}
      data={data}
      exportTransformFn={exportTransformFn}
      renderRowActions={getRowActions}
    />
  )
}
